var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 18.3333C38.5 31.1667 22 42.1667 22 42.1667C22 42.1667 5.5 31.1667 5.5 18.3333C5.5 13.9573 7.23839 9.76042 10.3327 6.66607C13.4271 3.57172 17.6239 1.83334 22 1.83334C26.3761 1.83334 30.5729 3.57172 33.6673 6.66607C36.7616 9.76042 38.5 13.9573 38.5 18.3333Z",
    fill: "#0096FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.8333C25.0376 23.8333 27.5 21.3709 27.5 18.3333C27.5 15.2958 25.0376 12.8333 22 12.8333C18.9624 12.8333 16.5 15.2958 16.5 18.3333C16.5 21.3709 18.9624 23.8333 22 23.8333Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBlue);
export default __webpack_public_path__ + "static/media/markerBlue.8c5129aca64ad4165d568b9110288a33.svg";
export { ForwardRef as ReactComponent };